const countyCityMappings = require('./countyCityMappings.json')

// data taken from file from warehouse company
export const STATE_COUNTY = {
    "PE": {
        "AMA": { //Amazonas
            districts: [
                "Chachapoyas",
                "Bagua",
                "Bongará",
                "Condorcanqui",
                "Luya",
                "Rodríguez de Mendoza",
                "Utcubamba"
            ]
        },
        "ANC": {  //Ancash
            districts: [
                "Huaraz",
                "Aija",
                "Antonio Raymondi",
                "Asunción",
                "Bolognesi",
                "Carhuaz",
                "Carlos Fermín Fitzcarrald",
                "Casma",
                "Corongo",
                "Huari",
                "Huarmey",
                "Huaylas",
                "Mariscal Luzuriaga",
                "Ocros",
                "Pallasca",
                "Pomabamba",
                "Recuay",
                "Santa",
                "Sihuas",
                "Yungay"
            ]
        },
        "APU": { //Apurimac
            districts: [
                "Abancay",
                "Andahuaylas",
                "Antabamba",
                "Aymaraes",
                "Cotabambas",
                "Chincheros",
                "Grau"
            ]
        },
        "ARE": {  //Arequipa
            districts: [
                "Arequipa",
                "Camaná",
                "Caravelí",
                "Castilla",
                "Caylloma",
                "Condesuyos",
                "Islay",
                "La Uniòn"
            ]
        },
        "AYA": { //Ayacucho
            districts: [
                "Huamanga",
                "Cangallo",
                "Huanca Sancos",
                "Huanta",
                "La Mar",
                "Lucanas",
                "Parinacochas",
                "Pàucar del Sara Sara",
                "Sucre",
                "Víctor Fajardo",
                "Vilcas Huamán"
            ]
        },
        "CAJ": { //Cajamarca
            districts: [
                "Cajamarca",
                "Cajabamba",
                "Celendín",
                "Chota",
                "Contumazá",
                "Cutervo",
                "Hualgayoc",
                "Jaén",
                "San Ignacio",
                "San Marcos",
                "San Miguel",
                "San Pablo",
                "Santa Cruz"
            ]
        },
        "CAL": {//Callao
            districts: [
                "Prov. Const. del Callao"
            ]
        },
        "CUS": { //Cuzco
            districts: [
                "Cusco",
                "Acomayo",
                "Anta",
                "Calca",
                "Canas",
                "Canchis",
                "Chumbivilcas",
                "Espinar",
                "La Convención",
                "Paruro",
                "Paucartambo",
                "Quispicanchi",
                "Urubamba"
            ]
        },
        "HUV": { //Huancavelica
            districts: [
                "Huancavelica",
                "Acobamba",
                "Angaraes",
                "Castrovirreyna",
                "Churcampa",
                "Huaytará",
                "Tayacaja"
            ]
        },
        "HUC": { //Huánuco
            districts: [
                "Huánuco",
                "Ambo",
                "Dos de Mayo",
                "Huacaybamba",
                "Huamalíes",
                "Leoncio Prado",
                "Marañón",
                "Pachitea",
                "Puerto Inca",
                "Lauricocha",
                "Yarowilca"

            ]
        },
        "ICA": { //Ica
            districts: [
                "Ica",
                "Chincha",
                "Nasca",
                "Palpa",
                "Pisco"
            ]
        },
        "JUN": { //Junín
            districts: [
                "Huancayo",
                "Concepción",
                "Chanchamayo",
                "Jauja",
                "Junín",
                "Satipo",
                "Tarma",
                "Yauli",
                "Chupaca"
            ]
        },
        "LAL": {  //La Libertad
            districts: [
                "Trujillo",
                "Ascope",
                "Bolívar",
                "Chepén",
                "Julcán",
                "Otuzco",
                "Pacasmayo",
                "Pataz",
                "Sánchez Carrión",
                "Santiago de Chuco",
                "Gran Chimú",
                "Virú"
            ]
        },
        "LAM": { //Lambayeque
            districts: [
                "Chiclayo",
                "Ferreñafe",
                "Lambayeque"
            ]
        },
        "LIM": { //Lima
            districts: [
                "Lima",
                "Barranca",
                "Cajatambo",
                "Canta",
                "Cañete",
                "Huaral",
                "Huarochirí",
                "Huaura",
                "Oyón",
                "Yauyos"
            ]
        },
        "LOR": { //Loreto
            districts: [
                "Maynas",
                "Alto Amazonas",
                "Loreto",
                "Mariscal Ramón Castilla",
                "Requena",
                "Ucayali",
                "Datem del Marañón"
            ]
        },
        "MDD": { //Madre de Dios
            districts: [
                "Tambopata",
                "Tambopata",
                "Manu",
                "Tahuamanu"
            ]
        },
        "MOQ": { //Moquegua
            districts: [
                "Mariscal Nieto",
                "General Sánchez Cerro",
                "Ilo"
            ]
        },
        "PAS": { //Pasco
            districts: [
                "Pasco",
                "Daniel Alcides Carrión",
                "Oxapampa"
            ]
        },
        "PIU": { //Piura
            districts: [
                "Piura",
                "Ayabaca",
                "Huancabamba",
                "Morropón",
                "Paita",
                "Sullana",
                "Talara",
                "Sechura"
            ]
        },
        "PUN": { //Puno
            districts: [
                "Puno",
                "Azángaro",
                "Carabaya",
                "Chucuito",
                "El Collao",
                "Huancané",
                "Lampa",
                "Melgar",
                "Moho",
                "San Antonio de Putina",
                "San Román",
                "Sandia",
                "Yunguyo"
            ]
        },
        "SAM": { //San Martin
            districts: [
                "Moyobamba",
                "Bellavista",
                "El Dorado",
                "Huallaga",
                "Lamas",
                "Mariscal Cáceres",
                "Picota",
                "Rioja",
                "San Martín",
                "Tocache"
            ]
        },
        "TAC": { //Tacna
            districts: [
                "Tacna",
                "Candarave",
                "Jorge Basadre",
                "Tarata"
            ]
        },
        "TUM": { //Tumbes
            districts: [
                "Tumbes",
                "Contralmirante Villar",
                "Zarumilla"
            ]
        },
        "UCA": { //Ucayali
            districts: [
                "Coronel Portillo",
                "Atalaya",
                "Padre Abad",
                "Purús"
            ]
        }
    }
};

export const COUNTY_CITY = countyCityMappings;